module.exports = __webpack_public_path__ + "img/05-avatar male.845f206e.png";